import { render, staticRenderFns } from "./flat-cards.vue?vue&type=template&id=0d855df7&scoped=true&"
import script from "./flat-cards.vue?vue&type=script&lang=js&"
export * from "./flat-cards.vue?vue&type=script&lang=js&"
import style0 from "./flat-cards.vue?vue&type=style&index=0&id=0d855df7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d855df7",
  null
  
)

export default component.exports